import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  z-index: 10003;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

export const Modal = styled.div`
  width: 100%;
  max-width: 540px;
  border-radius: 8px;
  border: 1px solid var(--neutral-100, #e8e8e9);
  background: #fff;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 16px 0;

  button {
    border: 0;
    background: transparent;
    cursor: pointer;
    padding: 0;
    display: flex;
  }

  h1 {
    margin: 0;
    font-size: 20px;
    color: #000;
  }
`;

export const Content = styled.p`
  margin: 0;
  padding: 12px 16px 0;
  color: #7a797a;
  line-height: 1.5;
  white-space: pre-line;
`;

export const Footer = styled.div`
  padding: 24px 16px 16px;
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 12px;

  button {
    min-width: 180px;
  }

  @media (max-width: 480px) {
    a {
      width: 100%;
      text-align: center;
    }
  }
`;
